// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"ab5abee4","787":"8e0bf0c8"}[chunkId] + ".chunk.js";
};